import { render } from "./MenuForm.vue?vue&type=template&id=e7e9c3e6&scoped=true&ts=true"
import script from "./MenuForm.vue?vue&type=script&lang=ts"
export * from "./MenuForm.vue?vue&type=script&lang=ts"

import "./MenuForm.vue?vue&type=style&index=0&id=e7e9c3e6&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e9c3e6"]])

export default __exports__